/* eslint-disable jsx-a11y/media-has-caption */
import { Paper, Typography } from '@material-ui/core';
import DescriptionIcon from '@material-ui/icons/Description';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

type ChatMessageFileProps = {
  mediaUrl: string;
  mediaName?: string;
};

const ChatMessageFile: React.FC<ChatMessageFileProps> = ({
  mediaName = '',
  mediaUrl,
}) => {
  // TODO it is better to deal with through real MIME types
  const intl = useIntl();

  const isAudio = useMemo(
    () => mediaUrl && /\S+\.(mp3|ogg|oga)$/.test(mediaUrl),
    [mediaUrl]
  );

  if (isAudio) {
    return <audio controls src={mediaUrl} preload="metadata" />;
  }

  const openAttached = () => window.open(mediaUrl);

  return (
    <Paper elevation={0} style={{ cursor: 'pointer' }} onClick={openAttached}>
      <Typography color="primary">
        <div style={{ padding: 8, display: 'flex', alignItems: 'center' }}>
          <DescriptionIcon style={{ fontSize: '1.8rem' }} />
          <span style={{ fontSize: 13, marginLeft: '0.65rem', lineHeight: 1 }}>
            {mediaName ||
              intl.formatMessage({ id: 'ChatEvent.DownloadFileLink' })}
          </span>
        </div>
      </Typography>
    </Paper>
  );
};

export default ChatMessageFile;
